<template>
<div></div>
</template>
<script>
  import OrderTrackingMixin from 'app/mixins/OrderTrackingMixin'

  export default {
    mixins: [OrderTrackingMixin],
    props: ['order', 'prices', 'conversion_tracker_percent'],
    async mounted () {
      this.track_successful_order(this.order, this.prices)
    }
  }
</script>
